import React from "react";
import SearchInput from "./SearchInput";
import Conversations from "./Conversations";

const ChatSidebar = ({ onlineUsers }) => {
  return (
    <div className="border-r border-gray-4 rounded-r-3xl bg-white p-4 flex flex-col min-h-0 min-w-0 w-[450px]">
      <SearchInput />
      <div className="my-1"></div>
      {/* Replacing DaisyUI divider with a border */}
      <Conversations onlineUsers={onlineUsers} />
    </div>
  );
};

export default ChatSidebar;
